/**
 * InflowPay SDK v2 - Entry point
 *
 * Provides the same API as the original React SDK but using iframe-based payment flow
 * Compatible with vanilla JavaScript and easy migration from React SDK
 */

export { InflowPayProvider } from './inflowpay-provider';
export type { CardElementProps, InflowPayProviderConfig } from './inflowpay-provider';

export { PaymentSDK } from './payment-sdk';
export type { PaymentSDKConfig } from './payment-sdk';

export { CardElement } from './card-element';
export type { CardElementOptions } from './card-element';

export type {
  AppearanceVariables,
  CardElementState,
  CardFieldLayout,
  CssFontSource,
  PaymentConfig,
  PaymentElementAppearance,
  PaymentElementOptions,
  PaymentError,
  PaymentMethodLayout,
  PaymentMethodType,
  PaymentResult,
  SaveCardResult,
} from './types';

export { PaymentResultErrorCode, PaymentResultStatus } from './types';

export const VERSION = '1.9.0';
